import Vue from 'vue'
import store from './store/index'
import App from './App'
import router from './router'
import VueLazyload from 'vue-lazyload';
import vueAwesomeSwiper from 'vue-awesome-swiper';
/*import 'swiper/dist/css/swiper.css'*/
Vue.config.productionTip = false;
Vue.use(vueAwesomeSwiper);
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

Vue.use(LoadingPlugin);
Vue.use(ConfirmPlugin);
Vue.use(ToastPlugin);
Vue.use(AlertPlugin);
Vue.use(VueLazyload, {
preLoad: 1.3,
error: '../static/images/imgEorr.png',
attempt: 1,

})
const FastClick = require('fastclick')
FastClick.attach(document.body)
require('es6-promise').polyfill();
import 'url-search-params-polyfill';
/* eslint-disable no-new */


const history = window.sessionStorage;
history.clear();
let historyCount = history.getItem('count') * 1 || 0;
history.setItem('/',0);

router.beforeEach((to, from, next) => {

const toIndex = history.getItem(to.path);
const formIndex = history.getItem(from.path);
if(toIndex){
if (!formIndex || parseInt(toIndex,10) > parseInt(formIndex,10) || (toIndex === '0' && formIndex === '0')){
store.commit('UPDATE_DIRECTION',{direction:'forward'})
}else {
store.commit('UPDATE_DIRECTION',{direction:'reverse'})
}
}else {
++historyCount;
history.setItem('count',historyCount);
to.path !== '/' && history.setItem(to.path,historyCount);
store.commit('UPDATE_DIRECTION',{direction:'forward'})
}
store.commit('updateLoadingStatus',{isLoading:true})
next()
});
router.afterEach((to) =>{
store.commit('updateLoadingStatus',{isLoading:false})
});

new Vue({
el: '#app',
router,
store,
template: '<App/>',
components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js